__turbopack_context__.v({
  "paginator": "paginator-component-module-scss-module__U2SOrG__paginator",
  "paginator__button": "paginator-component-module-scss-module__U2SOrG__paginator__button",
  "paginator__buttons": "paginator-component-module-scss-module__U2SOrG__paginator__buttons",
  "paginator__carousel-wrapper": "paginator-component-module-scss-module__U2SOrG__paginator__carousel-wrapper",
  "paginator__index-link": "paginator-component-module-scss-module__U2SOrG__paginator__index-link",
  "paginator__indexes": "paginator-component-module-scss-module__U2SOrG__paginator__indexes",
  "paginator__indexes--first-page": "paginator-component-module-scss-module__U2SOrG__paginator__indexes--first-page",
  "paginator__indexes--last-page": "paginator-component-module-scss-module__U2SOrG__paginator__indexes--last-page",
  "paginator__item": "paginator-component-module-scss-module__U2SOrG__paginator__item",
  "paginator__item--active": "paginator-component-module-scss-module__U2SOrG__paginator__item--active",
  "paginator__item-link": "paginator-component-module-scss-module__U2SOrG__paginator__item-link",
  "paginator__item-link__dots": "paginator-component-module-scss-module__U2SOrG__paginator__item-link__dots",
  "paginator__list": "paginator-component-module-scss-module__U2SOrG__paginator__list",
});
